import {Roles} from "../../Enums"
import { PolicyConstants } from "../constants/PolicyConstants";
import { PermissionConstants } from "../constants/PermissionConstants";

export class UserDataPolicies{

    public static Name = PolicyConstants.USER_DATA_POLICIES;
    public static PermissionSets = [PermissionConstants.READ, PermissionConstants.EDIT];

    private static _readRestrictions : Roles[] =
    [
        Roles.Hauptbenutzer,
        Roles.Benutzer,
        Roles.BenutzerFinanz
    ];

    private static _editRestrictions =
    [
        Roles.Hauptbenutzer,
        Roles.Benutzer
    ];

    public static GetPermissions(){
        return new Map([
            [PermissionConstants.READ, this._readRestrictions],
            [PermissionConstants.EDIT, this._editRestrictions]
        ])
    }

}